import React, { useState } from 'react';
import Popover from '@material-ui/core/Popover';
import { withStyles } from '@material-ui/styles';
import { ProductPickerStyles } from './style';
import { Button, Tooltip, Typography } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { getDarkOrLightColor } from '../../../../../services/helpers';
import * as Icons from '@material-ui/icons';
import ColorPicker from '../ColorPicker';
import { toastr } from 'react-redux-toastr';

const ProductPicker = ({
    classes,
    color,
    changeActiveFiller,
    disabled,
    fillers,
    changeActiveShape,
    changeBorderColour,
    isAddItemInActive,
    currentFiller
}) => {
    const [anchorEl, setAnchorEl] = useState();
    const [anchorShapeEl, setAnchorShapeEl] = useState();
    const shapes = [
        { name: 'Round', icon: 'RadioButtonUnchecked' },
        // { name: 'Triangle', icon: 'ChangeHistory' },
        { name: 'Square', icon: 'CheckBoxOutlineBlank' }
    ];
    const [currentShape, setCurrentShape] = useState('Round');
    const [borderColour, setBorderColour] = useState();
    const CurrentShapeIconComponent = Icons[shapes.find(shape => shape.name === currentShape).icon];
    return (
        <>
            <Tooltip title="Select filler" classes={{ tooltip: classes.tooltip }}>
                <Button
                    className={`${classes.colorPickerButton} ${
                        disabled || !isAddItemInActive ? classes.pickerButtonDisabled : ''
                    }`}
                    style={{
                        background: color || '#ffffff',
                        opacity: disabled || !isAddItemInActive ? 0.5 : 1,
                        borderColor: fillers.length && !currentFiller ? 'red' : 'rgba(0, 0, 0, 0.23)'
                    }}
                    onClick={e => {
                        if (!isAddItemInActive) {
                            return toastr.error('Please click the Add item button');
                        }
                        if (!disabled && fillers.length) setAnchorEl(e.currentTarget);
                    }}
                    // disabled={disabled}
                >
                    <KeyboardArrowDownIcon
                        style={{ color: getDarkOrLightColor(color || '#ffffff', '#ffffff', '#666') }}
                    />
                </Button>
            </Tooltip>
            <Popover
                id="color-picker-popover"
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl()}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                <div className={classes.selectorArea}>
                    {fillers.map((fillerItem, index) => {
                        return (
                            <div
                                key={fillerItem.id}
                                className={`${classes.filler} ${fillers.length - 1 !== index ? classes.margin : ''}`}
                                onClick={() => {
                                    changeActiveFiller(fillerItem.filler.id, fillerItem.quantity);
                                    setAnchorEl();
                                }}
                            >
                                <Typography>{fillerItem.filler.name}</Typography>
                                <Button
                                    className={classes.colorPickerButton}
                                    style={{ background: fillerItem.color || 'white' }}
                                    disabled={true}
                                />
                            </div>
                        );
                    })}
                </div>
            </Popover>
            <Tooltip title="Dose shape" classes={{ tooltip: classes.tooltip }}>
                <Button
                    className={`${classes.colorPickerButton} ${
                        disabled || !currentFiller || !isAddItemInActive ? classes.pickerButtonDisabled : ''
                    }`}
                    style={{
                        background: color || '#ffffff',
                        marginLeft: 10,
                        marginRight: 10,
                        opacity: disabled || !currentFiller || !isAddItemInActive ? 0.5 : 1,
                        borderColor: 'rgba(0, 0, 0, 0.23)'
                    }}
                    onClick={e => {
                        if (!isAddItemInActive) {
                            return toastr.error('Please click the Add item button');
                        }
                        if (!currentFiller) {
                            return toastr.error('Filler is not selected');
                        }
                        if (!disabled && fillers.length && currentFiller) setAnchorShapeEl(e.currentTarget);
                    }}
                    // disabled={disabled}
                >
                    <CurrentShapeIconComponent
                        style={{ color: getDarkOrLightColor(color || '#ffffff', '#ffffff', '#666') }}
                    />
                </Button>
            </Tooltip>
            <Popover
                id="chape-picker-popover"
                open={Boolean(anchorShapeEl)}
                anchorEl={anchorShapeEl}
                onClose={() => setAnchorShapeEl()}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
            >
                <div className={classes.selectorShapeArea}>
                    {shapes.map(shape => {
                        const IconComponent = Icons[shape.icon];
                        return (
                            <div
                                key={shape.icon}
                                onClick={() => {
                                    setCurrentShape(shape.name);
                                    changeActiveShape(shape.name);
                                    setAnchorShapeEl(false);
                                }}
                            >
                                <IconComponent />
                            </div>
                        );
                    })}
                </div>
            </Popover>

            <Tooltip title="Border colour" classes={{ tooltip: classes.tooltip }}>
                <div
                    style={{ display: 'inline-block' }}
                    onClick={() => {
                        if (!isAddItemInActive) {
                            return toastr.error('Please click the Add item button');
                        }
                        if (!currentFiller) {
                            return toastr.error('Filler is not selected');
                        }
                    }}
                >
                    <ColorPicker
                        color={borderColour}
                        changeColor={colour => {
                            setBorderColour(colour.hex);
                            changeBorderColour(colour.hex);
                        }}
                        removeColourOnSecondClick={true}
                        icon={'BorderColorIcon'}
                        disabled={disabled || !isAddItemInActive || !currentFiller}
                    />
                </div>
            </Tooltip>
        </>
    );
};

ProductPicker.propTypes = {
    color: PropTypes.string,
    changeActiveFiller: PropTypes.func.isRequired,
    fillers: PropTypes.array.isRequired,
    classes: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    changeActiveShape: PropTypes.func.isRequired,
    changeBorderColour: PropTypes.func.isRequired,
    currentFiller: PropTypes.string,
    isAddItemInActive: PropTypes.bool
};

export default withStyles(ProductPickerStyles)(ProductPicker);
